import { OnlyLettersDirective } from './directives/onlyletters-directive';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import ptBr from '@angular/common/locales/pt';
import { registerLocaleData , CommonModule } from '@angular/common'
import { MessageComponent } from './components/message/message.component';
import { LoaderComponent } from './components/loader/loader.component';
import { EnderecoComponent } from './components/endereco/endereco.component';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { MonetaryMaskDirective } from './directives/monetary-mask.directive';
import { OnlyNumbersDirective } from './directives/onlynumber-directive';
import { MasksHelper } from './helpers/masks-helpers';


export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    MessageComponent,
    LoaderComponent,
    EnderecoComponent,
    MonetaryMaskDirective,
    OnlyNumbersDirective,
    OnlyLettersDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    MessageComponent,
    LoaderComponent,
    EnderecoComponent,
    MonetaryMaskDirective,
    OnlyNumbersDirective,
    OnlyLettersDirective
  ],
  providers:    [
    { provide: LOCALE_ID, useValue: 'pt' },
    // *************************************************
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    // *************************************************
  ],
})

export class SharedModule {}
